import { pageTop } from "./js-page-top.js";
import { createBreadcrumbs } from "./js-breadcrumbs.js";
import { productDescriptionAnchor } from "./js-product-description-anchor.js";
import { urRecentlyViewed } from "./js-ur-recently-viewed-products.js?v=3"; // app シンプル商品閲覧履歴アプリ関連
import { appPaid } from "./js-app-paid.js?v=0"; // app シンプル商品閲覧履歴アプリ関連

document.addEventListener('DOMContentLoaded', () => {
  pageTop();
  createBreadcrumbs();
  productDescriptionAnchor();
  urRecentlyViewed();
  appPaid();
});
